<template>
  <div>
    <v-carousel
      cycle
      interval="7000"
      height="100vh"
      show-arrows-on-hover
      hide-delimiters
    >
      <!-- Slide -->
      <v-carousel-item
        v-for="(slide, i) in customers.banners"
        :key="i"
        :src="slide.image"
        reverse-transition="scroll-x-transition"
        transition="scroll-x-transition"
      >
        <v-sheet color="transparent">
          <!-- Logo -->
          <v-row class="justify-start">
            <router-link :to="'/' + customers.url">
              <v-avatar
                size="70"
                class="logoSlide ma-6 animate__animated animate__fadeIn"
              >
                <v-img
                  :aspect-ratio="1 / 1"
                  src="@/assets/namya_logo.png"
                  alt="Logo"
                />
              </v-avatar>
            </router-link>
          </v-row>
        </v-sheet>
        <!-- Shopping -->
        <v-sheet class="shop" color="transparent">
          <!-- v-show="customers.isRestaurant || customers.isBusinessOrder" -->
          <v-row class="align-center justify-center">
            <v-col cols="12" md="6" sm="12" style="text-align: -webkit-center">
              <v-card
                class="center d-flex flex-column align-center flex-wrap cardShop mx-1 rounded-xl animate__animated animate__fadeIn"
                elevation="0"
                max-width="450"
              >
                <!--  -->
                <div class="main">
                  <div class="up">
                    <v-tooltip
                      left
                      nudge-top="30"
                      nudge-right="20"
                      color="#cc39a4"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="card1"
                          target="_blank"
                          :href="
                            'https://o.namya.ir/' + customers.url + '/menu'
                          "
                          v-bind="attrs"
                          v-on="on"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            class="instagram"
                          >
                            <path
                              d="M21.999 8a.997.997 0 0 0-.143-.515L19.147 2.97A2.01 2.01 0 0 0 17.433 2H6.565c-.698 0-1.355.372-1.714.971L2.142 7.485A.997.997 0 0 0 1.999 8c0 1.005.386 1.914 1 2.618V20a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h4v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-9.382c.614-.704 1-1.613 1-2.618zm-2.016.251A2.002 2.002 0 0 1 17.999 10c-1.103 0-2-.897-2-2 0-.068-.025-.128-.039-.192l.02-.004L15.219 4h2.214l2.55 4.251zm-9.977-.186L10.818 4h2.361l.813 4.065C13.957 9.138 13.079 10 11.999 10s-1.958-.862-1.993-1.935zM6.565 4h2.214l-.76 3.804.02.004c-.015.064-.04.124-.04.192 0 1.103-.897 2-2 2a2.002 2.002 0 0 1-1.984-1.749L6.565 4zm3.434 12h-4v-3h4v3z"
                            ></path>
                          </svg>
                          <strong class="showsm" id="strong"
                            >فروشگاه آنلاین</strong
                          >
                        </v-btn>
                      </template>
                      <span>فروشگاه آنلاین</span>
                    </v-tooltip>
                    <v-tooltip
                      right
                      nudge-top="30"
                      nudge-left="20"
                      color="#03a9f4"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="card2"
                          target="_blank"
                          href="https://namya.ir/m"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="30"
                            height="30"
                            class="twitter"
                          >
                            <path
                              d="M20 3H4c-1.103 0-2 .897-2 2v11c0 1.103.897 2 2 2h7v2H8v2h8v-2h-3v-2h7c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2zM4 14V5h16l.002 9H4z"
                            ></path>
                          </svg>
                          <strong class="showsm" id="strong"
                            >وب اپلیکیشن</strong
                          >
                        </v-btn>
                      </template>
                      <span>وب آپلیکیشن</span>
                    </v-tooltip>
                  </div>
                  <div class="down">
                    <v-tooltip
                      left
                      nudge-bottom="30"
                      nudge-right="20"
                      color="black"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="card3"
                          target="_blank"
                          href="https://namya.ir/namya.apk"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <strong class="mb-3 showsm" id="strong"
                            >دانلود اپ نامیا</strong
                          >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 30 30"
                            width="30"
                            height="30"
                            class="github"
                          >
                            <path d="m12 16 4-5h-3V4h-2v7H8z"></path>
                            <path
                              d="M20 18H4v-7H2v7c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-7h-2v7z"
                            ></path>
                          </svg>
                        </v-btn>
                      </template>
                      <span>دانلود اپ نامیا</span>
                    </v-tooltip>
                    <v-tooltip
                      right
                      nudge-bottom="30"
                      nudge-left="20"
                      color="#8c9eff"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="card4"
                          target="_blank"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <strong class="mb-4 showsm" id="strong"
                            >امکانات نامیا</strong
                          >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="30"
                            height="30"
                            viewBox="0 0 24 24"
                            class="discord"
                          >
                            <path
                              d="M4 13h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1zm-1 7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v4zm10 0a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v7zm1-10h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1z"
                            ></path>
                          </svg>
                        </v-btn>
                      </template>
                      <span>امکانات نامیا</span>
                    </v-tooltip>
                  </div>
                </div>
                <!--  -->
                <!-- <v-card-actions>
                  <v-btn
                    v-show="customers.isRestaurant"
                    style="justify-content: flex-center"
                    class="ma-2 px-2 animate__animated animate__backInRight rounded-lg"
                    target="blank"
                    large
                    dark
                    color="deep success"
                    :href="'https://r.namya.ir/' + customers.id + '/menu'"
                    >رستوران آنلاین</v-btn
                  >
                  <v-btn
                    v-show="customers.isBusinessOrder"
                    style="justify-content: flex-center"
                    class="ma-2 px-2 animate__animated animate__backInLeft rounded-lg"
                    target="blank"
                    large
                    dark
                    color="deep indigo"
                    :href="'https://o.namya.ir/' + customers.url + '/menu'"
                    >فروشگاه آنلاین</v-btn
                  >
                </v-card-actions> -->
                <v-row class="ma-0 showsm" align="center">
                  <v-col class="pa-0" cols="3" md="3" sm="3" align="center">
                    <v-btn
                      class="px-0"
                      text
                      plain
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://trustseal.enamad.ir/?id=228127&Code=SX9GI7jjWs9e6V42foSg"
                    >
                      <picture>
                        <source
                          type="image/webp"
                          srcset="@/assets/images/checked/enamad.png"
                        />
                        <v-img
                          :aspect-ratio="16 / 9"
                          class="m-1 cursor images"
                          height="100"
                          width="75"
                          src="@/assets/images/checked/enamad.png"
                        ></v-img>
                      </picture>
                    </v-btn>
                  </v-col>
                  <v-col cols="3" md="3" sm="3" align="center">
                    <picture class="px-0">
                      <source
                        type="image/webp"
                        srcset="@/assets/images/checked/kasbokar.png"
                      />
                      <v-img
                        :aspect-ratio="16 / 9"
                        class="m-1 cursor images"
                        height="100"
                        width="75"
                        src="@/assets/images/checked/kasbokar.png"
                      ></v-img>
                    </picture>
                  </v-col>
                  <v-col cols="3" md="3" sm="3" align="center">
                    <picture class="px-0">
                      <source
                        type="image/webp"
                        srcset="@/assets/images/checked/rezi.png"
                      />
                      <v-img
                        :aspect-ratio="16 / 9"
                        class="m-1 cursor images"
                        height="100"
                        width="75"
                        src="@/assets/images/checked/rezi.png"
                      ></v-img>
                    </picture>
                  </v-col>
                  <v-col cols="3" md="3" sm="3" align="center">
                    <v-btn
                      class="px-0"
                      text
                      plain
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://yazd.irannsr.org/fa/trade_unit/2458970/swd_id/106788/%D8%A7%D8%B9%D8%B6%D8%A7%DB%8C-%D8%AD%D9%82%D9%88%D9%82%DB%8C-%D9%86%D8%A7%D9%85%DB%8C%D8%A7%D8%A8-%D9%86%D9%88%DB%8C%D9%86-%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF.html"
                    >
                      <picture>
                        <source
                          type="image/webp"
                          srcset="@/assets/images/checked/irannsr.png"
                        />
                        <v-img
                          :aspect-ratio="16 / 9"
                          class="m-1 cursor images"
                          height="75"
                          width="70"
                          src="@/assets/images/checked/irannsr.png"
                        ></v-img>
                      </picture>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { useFavicon } from "@vueuse/core";
export default {
  data() {
    return {
      // customers: [],
      location: window.document.location.host.replace("www.", ""),
      type: "scale",
    };
  },
  props: {
    customers: {},
  },
  components: {},
  created() {
    // this.localbooth();
  },
  metaInfo() {
    return {
      title: "نامیا",
      titleTemplate: "%s | اولین نمایشگاه مجازی کسب و کارها",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.ir/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },
    ],
  },
  methods: {
    // async localbooth() {
    //   let response = await this.axios.get(
    //     "https://namya.ir/api/v1/businesses/booths/48"
    //   );
    //   this.customers = response.data.data;
    //   this.title = this.customers.name;
    //   this.keywords = this.customers.tags.map((tags) => `${tags.name}`);
    //   this.description = this.customers.aboutus;
    //   this.$emit("ID", this.customers.id);
    //   localStorage.setItem("ID", JSON.stringify(this.customers.id));
    //   this.tags = this.customers.tags;
    //   this.image = this.customers.image;
    //   var link = document.querySelector("link[rel~='icon']");
    //   // const icon = useFavicon();
    //   // icon.value = this.customers.image;
    // },
    DataReceive() {
      this.$emit("ID", this.customers.id);
    },
    calculateSectionOffsets() {
      let sections = document.getElementsByTagName("section");
      let length = sections.length;

      for (let i = 0; i < length; i++) {
        let sectionOffset = sections[i].offsetTop;
        this.offsets.push(sectionOffset);
      }
    },
  },
};
</script>

<style scoped>
.v-application .text-h4 {
  font-family: IRANSansX, sans-serif !important;
  letter-spacing: 0rem !important;
  color: #ffffff;
  font-size: 24px;
}

.v-application .subtitle-1,
.text-h6 {
  font-family: IRANSansX, sans-serif !important;
  letter-spacing: 0rem !important;
  color: #ffffff;
}
</style>

<style>
@media (280px <= width <= 370px) {
  .cardShop {
    animation-duration: 1s;
    background: rgba(0, 0, 0, 0.5) !important;
    margin-top: 112px !important;
  }
}

@media (370px < width <= 412px) {
  .cardShop {
    animation-duration: 1s;
    margin-bottom: 30px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

@media (412px < width <= 480px) {
  .cardShop {
    animation-duration: 1s;
    margin-bottom: 30px;
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

@media (480px < width <= 820px) {
  .cardShop {
    animation-duration: 1s;
    background: rgba(0, 0, 0, 0.5) !important;
    margin-bottom: 30px;
  }
}

@media (min-width: 821px) {
  .cardShop {
    animation-duration: 1s;
    margin-bottom: 70px;
    background: rgba(0, 0, 0, 0) !important;
  }
}

@media only screen and (min-width: 912px) {
  .logoSlide {
    display: none;
  }
}

@media only screen and (max-width: 912px) {
  .logoSlide {
    display: block;
    animation-duration: 2s;
  }
  .shop {
    position: relative;
    margin: 0;
    top: 70% !important;
    -ms-transform: translateY(-50%);
    transform: translateY(-70%);
  }
}

.shop {
  position: relative;
  margin: 0;
  top: 90%;
  -ms-transform: translateY(-50%);
  transform: translateY(-70%);
}

.showsm {
  display: none !important;
}
.showlg {
  display: block !important;
}
@media (max-width: 950px) {
  .showsm {
    display: flex !important;
  }
  .showlg {
    display: none !important;
  }
}
/* button */
.main {
  padding: 15px;
  direction: ltr;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}

.up {
  display: flex;
  flex-direction: row;
  gap: 0.5em;
}

.down {
  display: flex;
  flex-direction: row;
  gap: 0.5em;
}

.card1 {
  width: 90px;
  height: 90px !important;
  outline: none;
  border: none;
  background: white;
  border-radius: 90px 5px 5px 5px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: 0.2s ease-in-out;
}

.instagram {
  margin-top: 1.5em;
  margin-left: 1.2em;
  fill: #cc39a4;
}
.theme--light.v-btn.v-btn--has-bg {
  background-color: rgb(245 245 245 / 80%);
}

.card2 {
  width: 90px;
  height: 90px !important;
  outline: none;
  border: none;
  background: white;
  border-radius: 5px 90px 5px 5px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: 0.2s ease-in-out;
}

.twitter {
  margin-top: 1.5em;
  margin-left: -0.9em;
  fill: #03a9f4;
}

.card3 {
  width: 90px;
  height: 90px !important;
  outline: none;
  border: none;
  background: white;
  border-radius: 5px 5px 5px 90px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: 0.2s ease-in-out;
}

.github {
  margin-top: -0.6em;
  margin-left: 1.2em;
  fill: black;
}

.card4 {
  width: 90px;
  height: 90px !important;
  outline: none;
  border: none;
  background: white;
  border-radius: 5px 5px 90px 5px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px,
    rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;
  transition: 0.2s ease-in-out;
}

.discord {
  margin-top: -0.9em;
  margin-left: -1.2em;
  fill: #8c9eff;
}

.card1:hover {
  cursor: pointer;
  scale: 1.1;
  background-color: #cc39a4 !important;
}
.card1:hover #strong,
.card2:hover #strong,
.card3:hover #strong,
.card4:hover #strong {
  color: white;
}

.card1:hover .instagram {
  fill: white;
}

.card2:hover {
  cursor: pointer;
  scale: 1.1;
  background-color: #03a9f4 !important;
}

.card2:hover .twitter {
  fill: white;
}

.card3:hover {
  cursor: pointer;
  scale: 1.1;
  background-color: black !important;
}

.card3:hover .github {
  fill: white;
  color: white;
}

.card4:hover {
  cursor: pointer;
  scale: 1.1;
  background-color: #8c9eff !important;
  color: white;
}

.card4:hover .discord {
  fill: white;
  color: white;
}
.v-btn__content {
  flex-direction: column;
}
strong#strong {
  font-size: 11px;
  font-weight: 200;
  letter-spacing: 0px;
}
</style>
